import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { IAppState } from 'app/store';
import { LicenseService } from 'app/shared/services/license.service';
import { License } from 'app/shared/models/license';
import { take } from 'rxjs/operators';
import { KeyBase, ItemChanged, Key } from '@kpd/framework-ngx';
import { environment } from 'environments/environment';
import { UserManagementQueryFacade } from './usermanagement.facade';

@Injectable()
export class LicenseFacade extends UserManagementQueryFacade {
  excludeFromSelection: Key<string>[];

  constructor(licenseService: LicenseService, store: Store<IAppState>) {
    super('licenses', store, licenseService, environment);
  }

  composeKeyByRouteParams(params: { id: string }): KeyBase {
    return Key.composeKeyByRouteParams(params);
  }

  changeSelectionRelative(increment: number): void {
    combineLatest(this.index$, this.items$, this.itemsTotalCount$)
      .pipe(take(1))
      .subscribe((result) => {
        const [index, items, totalItems] = result;
        let newIndex: any;
        let indexIncrementer = increment;
        while (typeof newIndex === 'undefined' || this.isInRangeAndExcluded(newIndex, items, increment)) {
          newIndex = Math.max(Math.min((index as number) + indexIncrementer, (totalItems as number) - 1), 0);
          indexIncrementer += increment;
        }
        if (!this.excludeFromSelection.some((key) => key === items[newIndex].key)) {
          this.changeSelection(newIndex, [items[newIndex].key]);
        }
      });
  }

  private isInRangeAndExcluded(index: number, items: Array<any>, increment: number): boolean {
    return (
      index + increment >= 0 &&
      index + increment < items.length &&
      this.excludeFromSelection.some((key) => key === items[index].key)
    );
  }

  licenseChanged(license: License): void {
    this.store.dispatch(new ItemChanged('licenses', license));
  }
}
